/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class CompanyDataApi extends BaseApi {
  endPoint: string = '/api/admin/company-data';
}
